import { Paper, Box, CircularProgress, Typography } from '@mui/material';

/**
 * Loading state component for DataGrid
 * Displays a centered loading spinner with message
 */
export const LoadingState = () => {
  return (
    <Paper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: 8,
          gap: 2,
        }}
      >
        <CircularProgress size={48} color="primary" />
        <Typography variant="h6" color="text.secondary">
          Loading grid data...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This may take a moment for large datasets
        </Typography>
      </Box>
    </Paper>
  );
};
